import * as Yup from "yup";
import validationUtils from "./validationUtils";

const billingFormSchema = Yup.object().shape({
  first_name: validationUtils?.validateName("first_name"),

  last_name: validationUtils?.validateName("last_name"),

  phone_number: validationUtils?.validatePhoneNumber(),

  email: validationUtils?.validateEmail(),

  address: validationUtils?.validateRequiredAddress("address"),

  city: validationUtils?.validateRequiredAddress("city"),

  state: validationUtils?.validateRequiredAddress("state"),

  zipcode: validationUtils?.validateRequiredAddress("zipcode"),

  captcha_value: validationUtils?.validateCaptchaValue(),
});

export default billingFormSchema;
